import React from 'react';
import classNames from 'classnames';

import './card.scss';

export const Card = (props) => {
  const { children, type = 'transparent' } = props;

  const cardStyles = classNames('card', { 'white-card': type === 'white' });

  return (
    <div className={cardStyles}>
      {children}
      <div className="card-triangle" />
      <div className="card-triangle-line" />
    </div>
  );
};
